export enum LiveOrderFulfillmentType {
  DINE_IN = 'dine_in',
  TAKE_OUT = 'take_out',
}
